var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav__title -main"},[_vm._t("default"),(this.$parent.withSubNav)?_c('i',{staticClass:"ico--arr-down"}):_vm._e(),_c('router-link',{attrs:{"to":_vm.path || _vm.subnavPath}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }